'use client'

import { useEffect, useRef } from 'react'
import { useTheme } from '../theme'

// @refresh reset

const glyph0 = (
  background: string,
  fill: string
) => `<svg width="10" height="10" viewBox="-5 -5 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="-5" y="-5" width="20" height="20" fill="${background}"/>
<path d="M0 10V0H10V10H0Z" fill="${fill}"/>
</svg>

`

const glyph1 = (
  background: string,
  fill: string
) => `<svg width="10" height="10" viewBox="-5 -5 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="-5" y="-5" width="20" height="20" fill="${background}"/>
<path d="M0 10V0H10V10H0ZM0.866793 9.13885L9.13055 9.13885V0.872686L0.866793 0.872686V9.13885Z" fill="${fill}"/>
</svg>
`

const glyph2 = (
  background: string,
  fill: string
) => `<svg width="10" height="10" viewBox="-5 -5 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="-5" y="-5" width="20" height="20" fill="${background}"/>
<path d="M0 10V0H10V10H0ZM0.874317 9.12568H9.12568V0.874317H0.874317V9.12568ZM3.85246 6.14754V3.85246H6.14754V6.14754H3.85246Z" fill="${fill}"/>
</svg>
`

const glyph3 = (
  background: string,
  fill: string
) => `<svg width="10" height="10" viewBox="-5 -5 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="-5" y="-5" width="20" height="20" fill="${background}"/>
<path d="M0 10V0H10V10H0ZM0.874317 9.12568H9.12568V0.874317H0.874317V9.12568ZM3.30601 6.69399V3.30601H6.69399V6.69399H3.30601Z" fill="${fill}"/>
</svg>
`

const glyph4 = (
  background: string,
  fill: string
) => `<svg width="10" height="10" viewBox="-5 -5 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="-5" y="-5" width="20" height="20" fill="${background}"/>
<path d="M0 10V0H10V10H0ZM0.874317 9.12568H9.12568V0.874317H0.874317V9.12568ZM2.75956 7.24044V2.75956H7.24044V7.24044H2.75956Z" fill="${fill}"/>
</svg>  
`

const glyph5 = (
  background: string,
  fill: string
) => `<svg width="10" height="10" viewBox="-5 -5 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="-5" y="-5" width="20" height="20" fill="${background}"/>
<path d="M0 10V0H10V10H0ZM2.48634 7.51366H7.51366V2.48634H2.48634V7.51366Z" fill="${fill}"/>
</svg>
`

const glyph6 = (
  background: string,
  fill: string
) => `<svg width="10" height="10" viewBox="-5 -5 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="-5" y="-5" width="20" height="20" fill="${background}"/>
<path d="M0 10V0H10V10H0ZM0.874317 9.12568H9.12568V0.874317H0.874317V9.12568ZM1.91257 8.08743V1.91257H8.08743V8.08743H1.91257ZM2.78689 7.21312H7.21312V2.78689H2.78689V7.21312ZM3.82514 6.17486V3.82514H6.17486V6.17486H3.82514Z" fill="${fill}"/>
</svg>
`

const glyph7 = (
  background: string,
  fill: string
) => `<svg width="10" height="10" viewBox="-5 -5 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="-5" y="-5" width="20" height="20" fill="${background}"/>
<path d="M0 10V0H10V10H0ZM0.614754 2.33607H9.38525V0.614754H0.614754V2.33607ZM0.614754 4.68579H9.38525V2.96448H0.614754V4.68579ZM0.614754 7.02186H9.38525V5.30055H0.614754V7.02186ZM0.614754 9.38525H9.38525V7.63661H0.614754V9.38525Z" fill="${fill}"/>
</svg>
`

const glyph8 = (
  background: string,
  fill: string
) => `<svg width="10" height="10" viewBox="-5 -5 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="-5" y="-5" width="20" height="20" fill="${background}"/>
<path d="M0 10V0H10V10H0ZM0.614754 9.38525H2.33607V0.614754H0.614754V9.38525ZM2.96448 9.38525H4.68579V0.614754H2.96448V9.38525ZM5.30055 9.38525H7.02186V0.614754H5.30055V9.38525ZM7.65027 9.38525H9.38525V0.614754H7.65027V9.38525Z" fill="${fill}"/>
</svg>
`

const glyph9 = (
  background: string,
  fill: string
) => `<svg width="10" height="10" viewBox="-5 -5 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="-5" y="-5" width="20" height="20" fill="${background}"/>
<path d="M0 10V0H10V10H0ZM0.614754 2.33607H2.33607V0.614754H0.614754V2.33607ZM2.96448 2.33607H4.68579V0.614754H2.96448V2.33607ZM5.30055 2.33607H7.02186V0.614754H5.30055V2.33607ZM7.65027 2.33607H9.38525V0.614754H7.65027V2.33607ZM0.614754 4.68579H2.33607V2.96448H0.614754V4.68579ZM2.96448 4.68579H4.68579V2.96448H2.96448V4.68579ZM5.30055 4.68579H7.02186V2.96448H5.30055V4.68579ZM7.65027 4.68579H9.38525V2.96448H7.65027V4.68579ZM0.614754 7.02186H2.33607V5.30055H0.614754V7.02186ZM2.96448 7.02186H4.68579V5.30055H2.96448V7.02186ZM5.30055 7.02186H7.02186V5.30055H5.30055V7.02186ZM7.65027 7.02186H9.38525V5.30055H7.65027V7.02186ZM0.614754 9.38525H2.33607V7.63661H0.614754V9.38525ZM2.96448 9.38525H4.68579V7.63661H2.96448V9.38525ZM5.30055 9.38525H7.02186V7.63661H5.30055V9.38525ZM7.65027 9.38525H9.38525V7.63661H7.65027V9.38525Z" fill="${fill}"/>
</svg>
`

const glyph10 = (
  background: string,
  fill: string
) => `<svg width="10" height="10" viewBox="-5 -5 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="-5" y="-5" width="20" height="20" fill="${background}"/>
<path d="M0 10V0H10V10H0ZM9.38525 9.01639V6.5847L3.44262 0.614754H0.997268L9.38525 9.01639ZM9.38525 5.72404V3.2377L6.77596 0.614754H4.31694L9.38525 5.72404ZM9.38525 2.36339V0.614754H7.63661L9.38525 2.36339ZM6.42076 9.38525H8.86612L0.614754 1.12022V3.55191L6.42076 9.38525ZM3.21038 9.38525H5.54645L0.614754 4.41257V6.7623L3.21038 9.38525ZM0.614754 9.38525H2.33607L0.614754 7.63661V9.38525Z" fill="${fill}"/>
</svg>
`

const glyph11 = (
  background: string,
  fill: string
) => `<svg width="10" height="10" viewBox="-5 -5 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="-5" y="-5" width="20" height="20" fill="${background}"/>
<path d="M0 10V0H10V10H0ZM0.614754 5.72404L5.68306 0.614754H3.22404L0.614754 3.2377V5.72404ZM0.614754 9.01639L9.00273 0.614754H6.55738L0.614754 6.5847V9.01639ZM0.614754 2.36339L2.36339 0.614754H0.614754V2.36339ZM1.13388 9.38525H3.57924L9.38525 3.55191V1.12022L1.13388 9.38525ZM4.45355 9.38525H6.78962L9.38525 6.7623V4.41257L4.45355 9.38525ZM7.66393 9.38525H9.38525V7.63661L7.66393 9.38525Z" fill="${fill}"/>
</svg>
`

const glyph12 = (
  background: string,
  fill: string
) => `<svg width="10" height="10" viewBox="-5 -5 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="-5" y="-5" width="20" height="20" fill="${background}"/>
<path d="M0 10V0H10V10H0ZM1.69399 1.32514L2.39071 0.614754H0.997268L1.69399 1.32514ZM3.36066 2.9918L4.5765 1.77596L3.44262 0.614754H3.26503L2.11749 1.7623L3.36066 2.9918ZM5.01366 1.3388L5.72404 0.614754H4.31694L5.01366 1.3388ZM6.66667 2.9918L7.89617 1.7623L6.77596 0.614754H6.5847L5.45082 1.77596L6.66667 2.9918ZM8.33333 1.32514L9.03005 0.614754H7.63661L8.33333 1.32514ZM0.614754 2.39071L1.25683 1.7623L0.614754 1.12022V2.39071ZM9.38525 2.36339V1.14754L8.78415 1.7623L9.38525 2.36339ZM1.70765 4.64481L2.9235 3.42896L1.69399 2.21311L0.614754 3.27869V3.55191L1.70765 4.64481ZM5.01366 4.64481L6.24317 3.42896L5.01366 2.21311L3.79781 3.42896L5.01366 4.64481ZM8.30601 4.64481L9.38525 3.57924V3.2377L8.33333 2.21311L7.10383 3.44262L8.30601 4.64481ZM3.36066 6.29781L4.5765 5.08197L3.36066 3.86612L2.14481 5.08197L3.36066 6.29781ZM6.66667 6.29781L7.88251 5.08197L6.66667 3.87978L5.45082 5.09563L6.66667 6.29781ZM0.614754 5.75137L1.27049 5.08197L0.614754 4.41257V5.75137ZM9.38525 5.72404V4.45355L8.74317 5.08197L9.38525 5.72404ZM1.7623 7.90984L2.9235 6.73497L1.70765 5.51913L0.614754 6.62568V6.7623L1.7623 7.90984ZM8.27869 7.90984L9.38525 6.78962V6.5847L8.30601 5.51913L7.10383 6.73497L8.27869 7.90984ZM5.01366 7.97814L6.24317 6.73497L5.01366 5.53279L3.79781 6.7623L5.01366 7.97814ZM6.42076 9.38525H6.81694L7.84153 8.36066L6.66667 7.17213L5.45082 8.4153L6.42076 9.38525ZM3.21038 9.38525H3.60656L4.5765 8.4153L3.36066 7.18579L2.18579 8.36066L3.21038 9.38525ZM0.614754 9.04372L1.32514 8.347L0.614754 7.63661V9.04372ZM9.38525 9.01639V7.69126L8.71585 8.36066L9.38525 9.01639ZM1.17486 9.38525H2.33607L1.7623 8.79781L1.17486 9.38525ZM7.69126 9.38525H8.86612L8.27869 8.79781L7.69126 9.38525ZM4.48087 9.38525H5.54645L5.01366 8.85246L4.48087 9.38525Z" fill="${fill}"/>
</svg>
`

const glyph13 = (
  background: string,
  fill: string
) => `<svg width="10" height="10" viewBox="-5 -5 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="-5" y="-5" width="20" height="20" fill="${background}"/>
<path d="M0 9.19355C0 8.91577 0.0691563 8.71416 0.207469 8.58871C0.345781 8.4543 0.539419 8.3871 0.788382 8.3871C1.04657 8.3871 1.24481 8.4543 1.38313 8.58871C1.52144 8.71416 1.59059 8.91577 1.59059 9.19355C1.59059 9.46237 1.52144 9.66398 1.38313 9.79839C1.24481 9.9328 1.04657 10 0.788382 10C0.539419 10 0.345781 9.9328 0.207469 9.79839C0.0691563 9.66398 0 9.46237 0 9.19355ZM8.28492 9.19355C8.28492 8.91577 8.35408 8.71416 8.49239 8.58871C8.63071 8.4543 8.82434 8.3871 9.07331 8.3871C9.33149 8.3871 9.52974 8.4543 9.66805 8.58871C9.80636 8.71416 9.87552 8.91577 9.87552 9.19355C9.87552 9.46237 9.80636 9.66398 9.66805 9.79839C9.52974 9.9328 9.33149 10 9.07331 10C8.82434 10 8.63071 9.9328 8.49239 9.79839C8.35408 9.66398 8.28492 9.46237 8.28492 9.19355ZM0 0.806452C0 0.528674 0.0691563 0.327061 0.207469 0.201613C0.345781 0.0672042 0.539419 0 0.788382 0C1.04657 0 1.24481 0.0672042 1.38313 0.201613C1.52144 0.327061 1.59059 0.528674 1.59059 0.806452C1.59059 1.06631 1.52144 1.26344 1.38313 1.39785C1.24481 1.53226 1.04657 1.59946 0.788382 1.59946C0.539419 1.59946 0.345781 1.53226 0.207469 1.39785C0.0691563 1.26344 0 1.06631 0 0.806452ZM8.40941 0.806452C8.40941 0.528674 8.47856 0.327061 8.61687 0.201613C8.75519 0.0672042 8.94882 0 9.19779 0C9.45597 0 9.65422 0.0672042 9.79253 0.201613C9.93084 0.327061 10 0.528674 10 0.806452C10 1.06631 9.93084 1.26344 9.79253 1.39785C9.65422 1.53226 9.45597 1.59946 9.19779 1.59946C8.94882 1.59946 8.75519 1.53226 8.61687 1.39785C8.47856 1.26344 8.40941 1.06631 8.40941 0.806452Z" fill="${fill}"/>
</svg>`

const glyphs = [
  glyph0,
  glyph1,
  glyph2,
  glyph3,
  glyph4,
  glyph5,
  glyph6,
  glyph7,
  glyph8,
  glyph9,
  glyph10,
  glyph11,
  glyph12,
  glyph13,
]

export default function Favicon() {
  const indexCurrent = useRef(0)

  const { theme } = useTheme()

  useEffect(() => {
    const interval = setInterval(() => {
      const iconElement = document.querySelector('link[rel="icon"]')
      //   console.log(iconElement)
      //   iconElement?.setAttribute(
      //     'href',
      //     `/icons/glyph${indexCurrent.current}.svg`
      //   )

      const svgBase64 = btoa(
        unescape(
          encodeURIComponent(
            glyphs[indexCurrent.current](theme.primary, theme.secondary)
          )
        )
      )
      const dataUrl = `data:image/svg+xml;base64,${svgBase64}`

      iconElement?.setAttribute('href', dataUrl)
      iconElement?.setAttribute('type', 'image/svg+xml')

      indexCurrent.current++
      indexCurrent.current %= 13
    }, 500)

    return () => clearInterval(interval)
  }, [theme])

  return null
}
